var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCloseOutlined(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2692_31059)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.36326 5.57473C4.28523 5.65276 4.28518 5.77943 4.36329 5.85754L10.5858 12.0801L4.36326 18.3027C4.28523 18.3807 4.28518 18.5074 4.36329 18.5855L5.49467 19.7168C5.57277 19.7949 5.69944 19.7949 5.77747 19.7169L12 13.4943L18.2226 19.7168C18.3007 19.7949 18.4274 19.7949 18.5054 19.7169L19.6368 18.5854C19.7149 18.5074 19.7149 18.3807 19.6368 18.3026L13.4143 12.0801L19.6368 5.8575C19.7149 5.77947 19.7149 5.6528 19.6368 5.5747L18.5054 4.44332C18.4273 4.36522 18.3006 4.36526 18.2226 4.44329L12 10.6659L5.7775 4.44332C5.6994 4.36522 5.57273 4.36526 5.4947 4.44329L4.36326 5.57473Z",
    fill: "#8C8C8C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2692_31059"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.0800781)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseOutlined);
export default __webpack_public_path__ + "static/media/close-outlined.689560293ffab6b57cc7fe24b53ea5fe.svg";
export { ForwardRef as ReactComponent };